import React from "react";

/**
 * Styled display chip for the auto-calculated interest rate.
 * Supports negative values with amber/warning styling.
 * Props:
 *   value  number | ""  — the calculated rate value
 */
export default function InterestRateChip({ value }) {
  const numVal = Number(value);
  const hasValue = value !== "" && value !== null && value !== undefined && !isNaN(numVal) && numVal !== 0;
  const isNegative = hasValue && numVal < 0;

  return (
    <div className={`interest-rate-chip${isNegative ? " is-negative" : ""}`}>
      {hasValue ? (
        <>
          <span className="interest-rate-chip-value">{numVal.toFixed(2)}</span>
          <span className="interest-rate-chip-unit">%</span>
        </>
      ) : (
        <span className="interest-rate-chip-placeholder">בחר בסיס ריבית ומרווח</span>
      )}
    </div>
  );
}
